import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import UserIncomeRowsTableBody from './UserIncomeRowsTableBody';
import type { UserIncomeReportItemType } from '@econtractor/types';

interface UserIncomeRowsTableProps {
    rows: UserIncomeReportItemType[];
}

const UserIncomeRowsTable = ({ rows }: UserIncomeRowsTableProps) => {
    const { t } = useTranslation(['Reports']);

    return (
        <div className="crm-table-wrap">
            <Table className="ObjectRepTable UserIncomeRowsTable table-hover mb-0">
                <thead>
                    <tr className="bg-light">
                        <td className="head-name">{t('usersFields.object')}</td>
                        <td className="head-service">{t('usersFields.service')}</td>
                        <td className="head-date">{t('usersFields.date')}</td>
                        <td className="text-end head-income">{t('usersFields.income')}</td>
                    </tr>
                </thead>
                <UserIncomeRowsTableBody rows={rows} />
            </Table>
        </div>
    );
};

export default UserIncomeRowsTable;
